"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M6.633 3.15 18.33 8.782a1.507 1.507 0 0 1 .712 1.98l-.029.063 2.003.802 1.326-.442a.501.501 0 0 1 .382.027l1 .5a.5.5 0 0 1 .231.654l-2.5 5.5a.496.496 0 0 1-.455.294.505.505 0 0 1-.224-.053l-1-.5a.507.507 0 0 1-.251-.29l-.441-1.324-1.924-1.155-.28.608a1.492 1.492 0 0 1-1.363.872c-.222 0-.442-.05-.649-.15l-3.873-1.865v.02A2.505 2.505 0 0 1 9 16.61v3.55a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1 0-1H8v-3.05a2.504 2.504 0 0 1-2-2.45c0-.728.314-1.396.836-1.858L3.17 10.537a1.507 1.507 0 0 1-.712-1.98L4.62 3.873a1.49 1.49 0 0 1 .855-.783 1.485 1.485 0 0 1 1.158.06Zm11.96 8.584-1.011 2.191 2.175 1.306a.5.5 0 0 1 .218.27l.435 1.305.351.175 2.086-4.59-.384-.191-1.304.434a.502.502 0 0 1-.344-.01l-2.222-.89ZM7 14.16c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5c0-.118-.016-.238-.047-.359l-.768-.37a1 1 0 1 1-.542-.261l-.763-.367c-.533.241-.88.765-.88 1.357ZM5.982 4a.498.498 0 0 0-.454.291L3.366 8.977a.503.503 0 0 0 .237.66L15.3 15.268c.123.059.26.066.386.02a.489.489 0 0 0 .285-.261l2.162-4.684a.503.503 0 0 0-.237-.66L6.199 4.05A.496.496 0 0 0 5.982 4Z",
    clipRule: "evenodd"
  })]
});